:root {
  font-family: Inter, "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #f3f4f7;
  background: #070815;
  font-synthesis: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  --ink: #070815;
  --ink-soft: #111329;
  --graphite: #1a1f2e;
  --mist: #edeef2;
  --paper: #f6f6f3;
  --lilac: #9c91ff;
  --lilac-deep: #786bea;
  --mint: #c4fff6;
  --display: Inter, "Helvetica Neue", "Noto Sans", "Noto Sans CJK SC", "Droid Sans Fallback", Helvetica, Arial, sans-serif;
  --mono: "SFMono-Regular", "Roboto Mono", "Liberation Mono", "Droid Sans Fallback", Menlo, Consolas, monospace;
}

* { box-sizing: border-box; }

html {
  min-width: 320px;
  scroll-behavior: smooth;
  background: var(--ink);
}

body {
  min-width: 320px;
  min-height: 100vh;
  margin: 0;
  overflow-x: hidden;
  background: var(--ink);
}

button,
input { font: inherit; }

button,
a { -webkit-tap-highlight-color: transparent; }

a { color: inherit; }

button:focus-visible,
a:focus-visible,
input:focus-visible {
  outline: 2px solid var(--mint);
  outline-offset: 3px;
}

::selection {
  color: var(--ink);
  background: var(--mint);
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
